import { GlButton, GlTooltipDirective, GlIcon } from '@gitlab/ui';
export default {
    name: 'ReviewAppLink',
    components: {
        GlButton,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        cssClass: {
            type: String,
            required: true
        },
        display: {
            type: Object,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        size: {
            type: String,
            required: false,
            default: 'medium'
        }
    }
};
